import { render, staticRenderFns } from "./back2Top.vue?vue&type=template&id=ccbc8780&scoped=true&"
import script from "./back2Top.vue?vue&type=script&lang=js&"
export * from "./back2Top.vue?vue&type=script&lang=js&"
import style0 from "./back2Top.vue?vue&type=style&index=0&id=ccbc8780&lang=scss&scoped=true&"
import style1 from "./back2Top.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbc8780",
  null
  
)

export default component.exports